import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesProjectRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-permissions-associate',
	path: '/secure/project/SelectProjectPermissionScheme!default.jspa',
};
